import { colorsPalettes } from "@similarweb/styles";

import ChartTooltipContent from "./ChartTooltipContent/ChartTooltipContent";
import { DEFAULT_FULL_CHART_SIZE_NUM, MIN_CHART_VALUE } from "./constants";
import { Circle, CircleWrapper, StyledTooltip } from "./styles";

type SamTamChartSchema = {
    data: {
        reach: number;
        primaryDomain: string;
    };
};

const SamTamChart = ({ data }: SamTamChartSchema) => {
    const isDataToSmall = data?.reach < MIN_CHART_VALUE;
    const value = isDataToSmall && data?.reach !== 0 ? MIN_CHART_VALUE : data?.reach;

    return (
        <CircleWrapper className="SamTamCircleWrapper">
            <Circle
                color={colorsPalettes.blue[200]}
                width={DEFAULT_FULL_CHART_SIZE_NUM}
                height={DEFAULT_FULL_CHART_SIZE_NUM}
            />
            <StyledTooltip
                tooltipContent={
                    <ChartTooltipContent
                        percentageValue={`${data.reach}%`}
                        primaryName={data.primaryDomain}
                    />
                }
                variation="white"
            >
                <Circle
                    color={colorsPalettes.blue[500]}
                    width={value}
                    height={value}
                    isCenterCircle
                />
            </StyledTooltip>
        </CircleWrapper>
    );
};

export default SamTamChart;
